<template>
  <router-view></router-view>
</template>

<script>
// import Vue from 'vue'
export default {
  data () {
    return {
      // edit_id: {
      //   family_id: '',
      //   list_id: ''
      // }
    }
  },
  computed: {
    document () {
      return this.$store.getters.document
    },
    param () {
      return this.$route.params
    }
  },
  methods: {
    getDocument (id) {
      this.$store.dispatch('getDocument', id)
    },

    getUsersSelect () {
      this.$store.dispatch('getUsersSelect')
    },

    getUser () {
      this.$store.dispatch('getUser')
    },

    getOffices () {
      this.$store.dispatch('getOffices')
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.getDocument(to.params.id)
      vm.getUsersSelect()
      vm.getUser()
      vm.getOffices(to)
    })
  },
  mounted () {
  },
  route: {
  }
}
</script>

<style lang='scss' scoped>
.fade-leave-active {
  transition: opacity 0s;
  opacity: 0;
}
.fade-enter-active /* .fade-leave-active below version 2.1.8 */ {
  transition: opacity .3s;
}
.fa {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// Document.vue?2204bc88